// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../components';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import Dialog from 'material-ui/Dialog';
import { Multiselect } from 'react-widgets';
import CreateFixture from '../../partner/crud/createFixture';
import PartnerAllocation from '../../partner/partnerAllocation';
import VenueRent from '../../partner/crud/venueRent';
import BuddySalary from '../../partner/crud/buddySalary';
import AddExpense from '../crud/addExpense';

class ExpenseInfo extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue : this.props.venue,
      total_expense: 0,
      salary_tab: true,
      rent_tab: false,
      local_tab: false,
      marketing_tab: false,
      loading: true,
      buddy_dialog: false
    };
   this.handleSelection = this.handleSelection.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getExpense();
    // this.getFixtureGroups();
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getExpense(){
    const url = `${getLocationOrigin()}/cm/get_total_expense/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({total_expense:data.venue_local_expense_this_month,loading:false});
        }).catch(error => error);
    }

  
  handleOpen=()=>{
    this.setState({buddy_dialog:true})
  }
  handleClose=()=>{
    this.setState({buddy_dialog:false})
  }

  handleSelection(event){
    const name = event.target.name
    if(name == 'salary'){
      this.setState({salary_tab:true,rent_tab:false,local_tab:false,marketing_tab:false})
    }
    else if(name == 'rent'){
      this.setState({rent_tab:true,salary_tab:false,local_tab:false,marketing_tab:false})
    }
    else if(name == 'local'){
      this.setState({local_tab:true,salary_tab:false,rent_tab:false,marketing_tab:false})
    }
    else if(name == 'marketing'){
      this.setState({marketing_tab:true,salary_tab:false,rent_tab:false,local_tab:false})
    }
  }

  render() {
    console.log('venue',this.props)
    const actions = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleClose}
          />,
          <FlatButton
            label="Proceed"
            primary={true}
            onClick={this.postBuddies}
          />,
        ];

    return(
      <div style={styles.container}>
        {this.state.loading === true ?
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
          </div>
          :
          <div className='col-md-12'>
            <div className='col-md-12' style={{padding:'0px'}}>
              <button className='button1' style={{marginRight:'1%'}} name='salary' onClick={this.handleSelection}> Salary </button>
              <button className='button1' style={{marginRight:'1%'}} name='rent' onClick={this.handleSelection}> Rent </button>
              <button className='button1' style={{marginRight:'1%'}}  name='local' onClick={this.handleSelection}> Local Expense </button>
              <button className='button1' name='marketing' onClick={this.handleSelection}> Marketing Expense </button>

            </div>
            <div className='col-md-12'>
              { this.state.salary_tab &&
                <BuddySalary venue={this.state.venue}/>
              }

              { this.state.rent_tab &&
                <VenueRent venue={this.state.venue}/>
              }

              { this.state.local_tab &&
                <div className='col-md-12' style={{marginTop:"2%"}}>
                  <div className='label_blue_1' style={{textAlign:'center',padding:'1%',margin:'0% 18%'}}>
                    Total Expense for this Month -  &#8377; {this.state.total_expense}
                  </div>
                  <AddExpense className='col-md-8' venue={this.state.venue} from_partner_tab={true}/>
                </div>
              }

              { this.state.marketing_tab &&
                <div className='col-md-12' style={styles.title,{marginTop:"2%"}}>
                  Not Implemented Yet
                </div>
              }
            </div>
            
          </div>
        }
      </div>
    );
  }
}

export default ExpenseInfo;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/ExpenseInfo/ExpenseInfo.js